import React from 'react'
import {Button} from '@thryvlabs/maverick'
import {getKickoffCallLabelFromCart} from './kp-11Link-service'
import {
  CallHeading,
  ScheduledCallNotice,
  formatScheduledDateTime,
} from './scheduled-call-notice'

export const SchdulerSuccessComponent = ({
  scheduleCreativeCallDetails,
  scheduleKickOffCallDetails,
  isSkipped = false,
  accountInformation,
  handleModalClose,
  structuredCart,
  // Optional: lets the customer go back and pick another kickoff slot.
  onReschedule,
}) => {
  const kickoffCallLabel = getKickoffCallLabelFromCart(structuredCart)

  const scheduledCalls = [
    scheduleKickOffCallDetails?.isCallScheduled && {
      label: kickoffCallLabel,
      callDetails: scheduleKickOffCallDetails.callDetails,
      onReset: onReschedule,
    },
    scheduleCreativeCallDetails?.isCallScheduled && {
      label: 'Website Design Call',
      callDetails: scheduleCreativeCallDetails.callDetails,
    },
  ].filter(Boolean)

  return (
    <section
      style={{
        backgroundColor: '#F5F5F5',
        padding: '20px',
        borderRadius: '8px',
      }}
    >
      {scheduledCalls.map(({label, callDetails, onReset}) => (
        <div className="ps-success-call" key={label}>
          <CallHeading>{label}</CallHeading>
          <ScheduledCallNotice
            label={label}
            dateTime={formatScheduledDateTime(callDetails)}
            email={accountInformation?.email}
            onReset={onReset}
          />
        </div>
      ))}
      {isSkipped && (
        <div className="ps-notice ps-success-call">
          <p className="ps-notice-text">You have SKIPPED the meeting.</p>
        </div>
      )}
      <section className="d-flex justify-content-end mt-4">
        <Button
          variant="primary"
          className="ad-continue ad-schedule-action"
          onClick={() => {
            handleModalClose()
          }}
        >
          Continue
        </Button>
      </section>
    </section>
  )
}
